import React, { useEffect } from "react";
import { Form, SelectPicker } from "rsuite";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import {
  usePropertyStore,
  useIsOfflineProperty,
} from "../../contexts/PropertyStoreContext";
import {
  getRatePlansByPropertyId,
  selectRateplans,
  selectSelectedRateplan,
  setSelectedRateplan,
  selectLoading,
  selectEditableFilter,
  EDITABLE_FILTER,
} from "../../slices/rateplanSlice";
import "./rateplan.scss";

const RatePlan = ({ ...props }) => {
  const { selectedProperty } = usePropertyStore();
  const rateplans = useSelector(selectRateplans);
  const selectedRateplanDetail = useSelector(selectSelectedRateplan);
  const loadingRateplans = useSelector(selectLoading);
  const editableFilter = useSelector(selectEditableFilter);
  const isOffline = useIsOfflineProperty();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedProperty?.propertyId) {
      dispatch(getRatePlansByPropertyId(selectedProperty.propertyId));
    }
  }, [dispatch, selectedProperty?.propertyId]);

  const handleRatePlanSelect = (_, ratePlan) => {
    dispatch(setSelectedRateplan(ratePlan));
  };

  const filteredRateplans = isOffline
    ? rateplans
    : rateplans?.filter((item) => {
        if (editableFilter === EDITABLE_FILTER.EDITABLE)
          return item.additionalData?.isNegotiated === true;
        if (editableFilter === EDITABLE_FILTER.NON_EDITABLE)
          return !item.additionalData?.isNegotiated;
        return true;
      });

  const rateplansData = filteredRateplans?.map((item) => ({
    label:
      item.code && item.name
        ? `${item.code}-${item.name}`
        : item.name || item.code,
    value: item.id,
    data: item,
  }));

  return (
    <div {...props}>
      <Form.Group className="rateplan-container">
        <Loader loading={loadingRateplans} />
        <SelectPicker
          placeholder="Choose rate plan"
          data={rateplansData}
          onSelect={handleRatePlanSelect}
          value={selectedRateplanDetail?.value}
          style={{ width: 257 }}
          cleanable={false}
          data-testid="rate-plan-picker"
          // after switching back to certain property and coming back to first property select picker does not re-render even though the selected rateplan detail value changes so we added the key for re-rendering
          key={`${selectedProperty?.propertyId} - ${selectedRateplanDetail?.value}`}
        />
      </Form.Group>
    </div>
  );
};

export default RatePlan;
